import React from 'react'

import {useTranslation} from 'react-i18next'


function Login_Notice(props)
{
    const {t} = useTranslation();

    return (
        <div class="modal fade" id="login_notice_modal">
            <div class="modal-dialog modal-md">
                <div class="modal-content notification-modal">

                    {/* Modal Header */}
                    <div class="modal-header">
                        <h4 class="modal-title seninter-tit">
                            <span className='intename2'>{t('please_log_in')}</span>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    {/* Modal body */}
                    <div class="modal-body seninter">
                        <div class="text-center">{props.textLoginModal}</div>
                    </div>

                    {/* Modal footer */}
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" onClick={() => { props.modalCloseLoginBtnRef.current.click();props.gotoLogin(); }}>Login</button>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal" ref={props.modalCloseLoginBtnRef}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login_Notice